import {ClienteModel, OrdemServicoModel, PaginacaoParamModel} from './../model';
import { Component, OnInit } from '@angular/core';
import { OrdemServicoService } from '../service/ordem-servico.service';
import { MensagemService } from '../service/mensagem.service';
import { constants } from '../app-constants';
import {BuscarOrdemServicoIn, UsuarioLogadoModel} from '../model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService, MessageService} from 'primeng/api';
import { OrdemServicoDialogComponent } from '../ordem-servico-dialog/ordem-servico-dialog.component';
import {DatePipe} from '@angular/common';
import {TipoOsParamModel} from '../model/tipo-os-param.model';
import {QrCodeDialogComponent} from '../qr-code-dialog/qr-code-dialog.component';
import {DataService} from '../service/data.service';

@Component({
  selector: 'app-lista-ordem-servico',
  templateUrl: './lista-ordem-servico.component.html',
  styleUrls: ['./lista-ordem-servico.component.css'],
  styles: ['::ng-deep .ui-datepicker {top:40%!important; }','.search-results { height : 100%; overflow-y: scroll};']
})

export class ListaOrdemServicoComponent implements OnInit {

  numberPage = 1;
  buscarOrdemServicoIn: BuscarOrdemServicoIn = new BuscarOrdemServicoIn();
  osS: Array<any> = [];
  tipoOs: Array<any> = [];
  colunas: any[];
  cliente: ClienteModel;
  tipoOsParam: TipoOsParamModel = new TipoOsParamModel();
  paginacao: PaginacaoParamModel = new PaginacaoParamModel();
  enderecos: Array<any> = [];
  equipes: Array<any> = [];
  status: Array<any> = [];
  ativo: any;
  timer = 0;
  qrCodeSearch = false;
  firstMessage = false;

  display = false;
  displayModal = false;

  filters: {
    cod: {flag: boolean, value: any},
    end: {flag: boolean, value: any},
    equ: {flag: boolean, value: any},
    tip: {flag: boolean, value: any},
    dcr: {flag: boolean, value: any},
    dag: {flag: boolean, value: any},
    sts: {flag: boolean, value: any}
  };

 constructor(private router: ActivatedRoute,
              private ordemServicoService: OrdemServicoService,
              private loadingBar: NgxUiLoaderService,
              public dialogService: DialogService,
              private data: DataService) {
  }

  ngOnInit() {
    this.cliente = JSON.parse(localStorage.getItem(constants.clienteKey));
    this.ativo = JSON.parse(localStorage.getItem(constants.ativoKey));
    this.qrCodeSearch = false;

    this.filters = {
      cod: {flag: false, value: null},
      end: {flag: false, value: null},
      equ: {flag: false, value: null},
      tip: {flag: false, value: null},
      dcr: {flag: false, value: null},
      dag: {flag: false, value: null},
      sts: {flag: false, value: null}
    };

    if (this.cliente !== undefined) {
      this.listar();
    }

    this.colunas = [
      {field: 'codigo', header: 'Código'},
      {field: 'descricaoStatusOS', header: 'Status'},
      {field: 'resumoTipoOSAux', header: 'Tipo da Ordem de Serviço'},
      {field: 'ativosRequeridos', header: 'Ativo Requerido'},
      {field: 'enderecoCompleto', header: 'Endereço'},
      {field: 'nome', header: 'Tecnico (Equipe)'},
      {field: 'dataCriacao', header: 'Data Criação'},
      {field: 'dataDisponibilidade', header: 'Data Agendada'},
      {field: 'observacoes', header: 'Observações'}
    ];

    this.paginacao.paginaAtual = 1;
    this.paginacao.registrosPorPagina = 50;

    this.listarFiltros();
    this.listarEnderecos(this.paginacao);
    this.listarEquipes(this.paginacao);
    this.listarStatus(this.paginacao);

    this.data.currentMessage.subscribe(message => {
      if (message === 'aberta') {
        this.firstMessage = true;
        return;
      } else if (this.firstMessage === true) {
        this.osS = [];
        this.qrCodeSearch = true;
        const res =  JSON.parse(message);
        res.forEach(item => {
          item.dataCriacao = new Date(item.dataCriacao);
          item.dataCriacao = new DatePipe('pt-BR').transform(item.dataCriacao, constants.dateFormat);
          if (item.dataDisponibilidade != null) {
            item.dataDisponibilidade = new Date(item.dataDisponibilidade);
            item.dataDisponibilidade = new DatePipe('pt-BR').transform(item.dataDisponibilidade, constants.dateFormat);
          } else{
            item.dataDisponibilidade = '';
          }

          if (item.ativosRequeridos == null) {
            item.ativosRequeridos = [];
          } else {
            const atvAux = [];
            item.ativosRequeridos.forEach( item_interno => {
              atvAux.push(item_interno.numeroSerie + ' / ' + item_interno.numeroPatrimonio + ' ' +
                item_interno.descricao + ' (' + item_interno.fabricante + ') - ' + item_interno.modelo);
            });
            item.ativosRequeridos = atvAux;
          }
          this.osS.push(item);
        });
        this.firstMessage = false;
      }
    });
 }

  listar() {
    this.populaOrdemServicoIn();
    this.loadingBar.start();
    this.ordemServicoService.listarOsS(this.buscarOrdemServicoIn)
      .subscribe(response => {
          this.numberPage++;
          this.onSuccess(response.ordemServicoOut);
          this.loadingBar.stop();
        },
        error => {
          console.log(error);
          this.loadingBar.stop();
        });
  }

  onSuccess(res) {
    if (res) {
      res.forEach(item => {
        item.dataCriacao = new Date(item.dataCriacao);
        item.dataCriacao = new DatePipe('pt-BR').transform(item.dataCriacao, constants.dateFormat);
        if (item.dataDisponibilidade != null) {
          item.dataDisponibilidade = new Date(item.dataDisponibilidade);
          item.dataDisponibilidade = new DatePipe('pt-BR').transform(item.dataDisponibilidade, constants.dateFormat);
        } else {
          item.dataDisponibilidade = '';
        }
        if (item.ativosRequeridos == null) {
          item.ativosRequeridos = [];
        } else {
          const atvAux = [];
          item.ativosRequeridos.forEach( item_interno => {
            atvAux.push(item_interno.numeroSerie + ' / ' + item_interno.numeroPatrimonio + ' ' +
            item_interno.descricao + ' (' + item_interno.fabricante + ') - ' + item_interno.modelo);
          });
          item.ativosRequeridos = atvAux;
        }
        this.osS.push(item);
      });
    }
  }

  mostrar(os) {
    const ref = this.dialogService.open(OrdemServicoDialogComponent, {
      data: JSON.stringify(os),
      header: 'Detalhamento',
      width: '70%',
      contentStyle: {'max-height': '350px', 'overflow': 'auto'}
    });
  }

  buscarQRCode() {
    this.displayModal = false;
   const ref = this.dialogService.open(QrCodeDialogComponent, {
     data: JSON.stringify([1, 2, 3, 10, 12, 17, 18, 29]),
     header: 'Busca por QR Code',
     width: '70%',
     contentStyle: {'max-height': '350px', 'overflow': 'auto'}
     });
  }

  public onScroll() {
    this.buscarOrdemServicoIn.paginaAtual = this.numberPage;
    this.listar();
  }

  public listarFiltros () {
   this.ordemServicoService.listarTiposOSFiltro(this.tipoOsParam)
     .subscribe(response => {
       this.onSuccess_2(response.tipoResumo);
       this.loadingBar.stop();
   });
  }

  onSuccess_2 (res) {
    if (res) {
      res.forEach(item => {
        const auxTipo = {label: item, value: item};
        this.tipoOs.push(auxTipo);
      });
      this.tipoOs = this.tipoOs.sort((tipoOsA, tipoOsB) => tipoOsA['label'] > tipoOsB['label'] ? 1 : -1);
    }
  }

  public listarEnderecos(paginacao: PaginacaoParamModel) {
    this.loadingBar.start();
    this.ordemServicoService.listarEnderecos(paginacao)
      .subscribe(response => {
        this.onSuccess_3(response.enderecos);
        this.loadingBar.stop();
      });
  }
  onSuccess_3(res) {
    if (res) {
      res.forEach(endereco => {
        this.enderecos.push({label: endereco.enderecoCompleto, value: endereco.enderecoCompleto, id: endereco.enderecoId});
      });
    }
  }

  public listarEquipes(paginacao: PaginacaoParamModel) {
    this.loadingBar.start();
    this.ordemServicoService.listarEquipes(paginacao)
      .subscribe(response => {
        this.onSuccess_4(response.equipeOuts);
        this.loadingBar.stop();
      });
  }
  onSuccess_4(res) {
    if (res) {
      res.forEach(tecnico => {
        this.equipes.push({label: tecnico.tecnico, value: tecnico.tecnico, login: tecnico.login});
      });
    }
  }

  listarStatus (paginacao: PaginacaoParamModel) {
    this.loadingBar.start();
    this.ordemServicoService.listarStatus(paginacao)
      .subscribe(response => {
        this.onSuccess_5(response.statusOut);
        this.loadingBar.stop();
      });
  }
  onSuccess_5 (res) {
   const aux = [1, 2, 3, 10, 12, 17, 18, 29];
   if (res) {
     res.forEach(status => {
       if (aux.includes(status.id)) {
         this.status.push({label: status.descricao, value: status.descricao, id: status.id});
       }
     });
   }
  }

  limparBusca() {
   this.osS = new Array<any>();
   this.numberPage = 1;
   this.qrCodeSearch = false;
   this.listar();
  }

  buscarOSPorEndereco (endereco) {
    if (endereco.value.length >= 1) {
      this.enderecos.forEach(item => {
        if (item.label === endereco.value[0]) {
          this.filters.end.flag = true;
          this.filters.end.value = item.id;
        }
      });
    } else {
      this.filters.end.flag = false;
    }
    if (this.cliente !== undefined) {
      this.osS = new Array<any>();
      this.numberPage = 1;
      this.listar();
    }
  }

  buscarOSPorCodigo (cod) {
    if (cod.length < 3) {
      if (cod.length === 0) {
        this.filters.cod.flag = false;
        this.osS = new Array<any>();
        this.numberPage = 1;
        this.listar();
      } else {
        alert('Não é possível buscar código com menos de 3 caracteres!');
      }
    } else {
      cod = '%' + cod + '%';
      this.filters.cod.value = cod;
      this.filters.cod.flag = true;
      this.osS = new Array<any>();
      this.numberPage = 1;
      this.listar();
    }
  }

  buscarOSPorEquipe (equipe) {
   if (equipe.value.length > 0) {
     this.equipes.forEach(item => {
       if (item.label === equipe.value[0]) {
         this.filters.equ.value = item.login;
         this.filters.equ.flag = true;
       }
     });
   } else {
     this.filters.equ.flag = false;
   }
    this.osS = new Array<any>();
    this.numberPage = 1;
    this.listar();
  }

  buscarOSPorTipo (tipo) {
    if (tipo.value.length > 0) {
      this.tipoOs.forEach(item => {
        if (item.label === tipo.value[0]) {
          this.filters.tip.value = item.value;
          this.filters.tip.flag = true;
        }
      });
    } else {
      this.filters.tip.flag = false;
    }
    this.osS = new Array<any>();
    this.numberPage = 1;
    this.listar();
  }

  buscarOSPorDataCriacao (data) {
   if (data != null) {
     this.filters.dcr.flag = true;
     this.filters.dcr.value = data;
   } else {
     this.filters.dcr.flag = false;
   }
    this.osS = new Array<any>();
    this.numberPage = 1;
    this.listar();
  }

  buscarOSPorDataAgendamento (data) {
    if (data != null) {
      this.filters.dag.flag = true;
      this.filters.dag.value = data;
    } else {
      this.filters.dag.flag = false;
    }
    this.osS = new Array<any>();
    this.numberPage = 1;
    this.listar();
  }

  buscarOSPorStatus (status) {
    if (status.value.length > 0) {
      this.filters.sts.value = [];
      this.status.forEach( statusOut => {
        status.value.forEach( sts => {
          if (sts === statusOut.label) {
            this.filters.sts.flag = true;
            this.filters.sts.value.push(statusOut.id);
          }
        });
      });
    } else {
      this.filters.sts.flag = false;
    }
    this.osS = new Array<any>();
    this.numberPage = 1;
    this.listar();
  }

  populaOrdemServicoIn () {
    this.buscarOrdemServicoIn.paginaAtual = this.numberPage;
    this.buscarOrdemServicoIn.contratoId = this.cliente.clienteContratoId;
    if (this.filters.sts.flag) {
      this.buscarOrdemServicoIn.listStatusOs = this.filters.sts.value;
    } else {
      this.buscarOrdemServicoIn.listStatusOs = [1, 2, 3, 10, 12, 17, 18, 29];
    }
    if (this.filters.end.flag) {
      this.buscarOrdemServicoIn.enderecoId = this.filters.end.value;
    } else {
      this.buscarOrdemServicoIn.enderecoId = null;
    }
    if (this.filters.cod.flag) {
      this.buscarOrdemServicoIn.codigo = this.filters.cod.value;
    } else {
      this.buscarOrdemServicoIn.codigo = null;
    }
    if (this.filters.equ.flag) {
      this.buscarOrdemServicoIn.tecnicoFiltro = this.filters.equ.value;
    } else {
      this.buscarOrdemServicoIn.tecnicoFiltro = null;
    }
    if (this.filters.tip.flag) {
      this.buscarOrdemServicoIn.buscaFiltro = this.filters.tip.value;
    } else {
      this.buscarOrdemServicoIn.buscaFiltro = null;
    }
    if (this.filters.dcr.flag) {
      this.buscarOrdemServicoIn.dataCriacaoFiltro = this.filters.dcr.value;
    } else {
      this.buscarOrdemServicoIn.dataCriacaoFiltro = null;
    }
    if (this.filters.dag.flag) {
      this.buscarOrdemServicoIn.dataAgendadaFiltro = this.filters.dag.value;
    } else {
      this.buscarOrdemServicoIn.dataAgendadaFiltro = null;
    }
  }
}
